import React, { Fragment, useEffect, useState, useMemo } from "react";
import { Input, Select, Tooltip, Modal } from "antd";
import { CheckBoxInput } from "../../Buttons";
import RangePickerComp from "../../RangePickerComp";
import { Divs } from "../../StyledComponents";
import { FiAlertCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  ruleCarrying,
  validPostiConnect,
} from "../../../../helpers/ShipmentRules";
import TooltipInfo from "../../TooltipInfo";
import { numberRound } from "../../../../helpers/Utils";
import { setCodSelected } from "../../../../redux/Actions/orderAction";

const { Option } = Select;

const { confirm } = Modal;

// type = basic/bulk_action
// order_rows_total = in bulk action
export default function ShipmentAdditionalServices({
  order_rows,
  type = "basic",
  order_rows_total = 0,
  cod_details,
  order_type,
  delivery,
  variables,
  handleChangeText,
  errors,
  country_id,
  order,
  setSkipLabels,
  skip_labels,
  address,
}) {
  const [warningMessages, setWarningMessages] = useState([]);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const { parcel_terminals = [] } = useSelector((state) => state.options);
  const postiValid = useMemo(
    () =>
      validPostiConnect({
        order_type,
        delivery,
      }),
    [order_type, delivery]
  );

  const isCodDisabledByParcelTerminal = useMemo(() => {
    if (!address?.parcel_terminal_id || !parcel_terminals || typeof parcel_terminals !== 'object') {
      return false;
    }

    let allTerminals = [];
    Object.keys(parcel_terminals).forEach(provider => {
      if (parcel_terminals[provider] && typeof parcel_terminals[provider] === 'object') {
        Object.keys(parcel_terminals[provider]).forEach(country => {
          if (Array.isArray(parcel_terminals[provider][country])) {
            allTerminals = allTerminals.concat(parcel_terminals[provider][country]);
          }
        });
      }
    });

    const selectedTerminal = allTerminals.find(
      terminal => terminal.id === address.parcel_terminal_id || terminal.value === address.parcel_terminal_id
    );

    if (!selectedTerminal) {
      return false;
    }

    const terminalName = (selectedTerminal.title || selectedTerminal.name || selectedTerminal.label || selectedTerminal.address || '').toLowerCase();
    // const isVenipakDelivery = delivery?.startsWith('venipak') || terminalName.includes('venipak');

    // Disable COD for Drogas and Eurokos terminals
    if (terminalName.includes('drogas') || terminalName.includes('eurokos')) {
      return true;
    }

    // Disable COD for Venipak Pickup points (not parcel terminals/paštomatas)
    // if (isVenipakDelivery && (terminalName.includes('venipak pickup') || terminalName.includes('pickup'))) {
    //   return true;
    // }

    return false;
  }, [address?.parcel_terminal_id, parcel_terminals, delivery]);

  useEffect(() => {
    const initialMessages = [];
    if (variables?.cod && variables?.delivery_same_day) {
      initialMessages.push(
        "[Same day delivery + COD]: Choose another payment method or courier."
      );
    }
    dispatch(setCodSelected(variables?.cod));
    if (
      postiValid &&
      (variables?.recycle || variables?.connect) &&
      +variables?.weight < 25
    ) {
      if (variables?.recycle) {
        initialMessages.push("[Recycle]: Minimum weight must be 25.");
      }
      if (variables?.connect) {
        initialMessages.push("[Connect]: Minimum weight must be 25.");
      }
    }
    setWarningMessages(initialMessages);
  }, [
    postiValid,
    order_type,
    delivery,
    variables?.cod,
    variables?.delivery_same_day,
    variables?.recycle,
    variables?.connect,
    variables?.weight,
  ]);

  useEffect(() => {
    if (isCodDisabledByParcelTerminal && variables.cod) {
      handleChangeText({
        target: { name: "cod", value: false },
      });
    }
  }, [isCodDisabledByParcelTerminal]);

  const handleLoggerUpdate = async (checked, type) => {
    const { firstname, lastname } = user;
    const { id: orderId } = order;
    const isChecked = checked ? "on" : "off";
    const logData = {
      log_body: `${firstname} ${lastname}`,
      log_title: `${type} ${isChecked} ${orderId}`,
    };

    try {
      await axios.post("/api/v1/logger", logData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCodAmountLog = async (amount) => {
    const { firstname, lastname } = user;
    const { id: orderId } = order;
    const logData = {
      log_body: `${firstname} ${lastname}`,
      log_title: `COD amount ${amount} ${orderId}`,
    };

    try {
      await axios.post("/api/v1/logger", logData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      {type == "basic" && (
        <Divs className="d-flex">
          <>
            <div className="mr-1" style={{ width: "50%" }}>
              <span
                className={`text-bold ${errors?.packets?.length > 0 ? "text-danger" : ""
                  }`}
              >
                Packets
              </span>
              <Input
                type="number"
                min={0}
                className={`${errors.packets ? "error_border" : ""}`}
                placeholder="Enter"
                disabled={
                  delivery == "omniva_postMachine" ||
                  delivery == "lp_express_postMachine"
                }
                name="pack"
                value={variables.pack}
                onChange={(e) => handleChangeText(e)}
              />
              {errors.packets && (
                <div className="text-danger">{errors.packets}</div>
              )}
            </div>
            <div className="ml-1" style={{ width: "50%" }}>
              <span
                className={`text-bold ${errors?.weight?.length > 0 ? "text-danger" : ""
                  }`}
              >
                Weight
              </span>
              <Input
                type="number"
                min={0}
                className={`${errors.weight ? "error_border" : ""}`}
                placeholder="Enter"
                name="weight"
                value={variables.weight}
                onChange={(e) => handleChangeText(e)}
              />
              {errors.weight && (
                <div className="text-danger">
                  {errors.weight.map((e) => (
                    <div>{e}</div>
                  ))}
                </div>
              )}
            </div>
          </>
        </Divs>
      )}
      {order_type == "lp_express" && delivery == "lp_express_postMachine" ? (
        <Divs>
          <span className="text-bold">
            {variables.pack == 1 ? "Package size" : "Package sizes"}
          </span>

          <Select
            style={{ width: "100%" }}
            placeholder="Choose"
            value={variables.lp_express_sizes}
            onChange={(e) =>
              handleChangeText({
                target: { name: "lp_express_sizes", value: e },
              })
            }
          >
            <Option value="XSmall">XSmall</Option>
            <Option value="Small">Small</Option>
            <Option value="Medium">Medium</Option>
            <Option value="Large">Large</Option>
            <Option value="XLarge">XLarge</Option>
          </Select>
        </Divs>
      ) : null}

      <table className="table table-borderless">
        <tbody>
          {ruleCarrying({ order_type, delivery }) && (
            <tr>
              <td className="align-middle px-0  pb-1" colSpan={2}>
                <CheckBoxInput
                  choised="carrying"
                  color="#f7951e"
                  text="Carrying"
                  checked={variables.carrying}
                  onChange={(e) => {
                    handleChangeText({
                      target: { name: "carrying", value: e.target.checked },
                    });
                    handleLoggerUpdate(e.target.checked, "Carrying");
                  }}
                />
              </td>
            </tr>
          )}
          {postiValid && (
            <RenderPostiServices
              order_rows={order_rows}
              variables={variables}
              handleChangeText={handleChangeText}
            />
          )}
          {/* {postiValid && (
            <tr>
              <td className="align-middle px-0  pb-1" colSpan={2}>
                <CheckBoxInput
                  choised="recycle"
                  color="#f7951e"
                  text="Recycle"
                  checked={variables.recycle}
                  onChange={(e) =>
                    handleChangeText({
                      target: { name: "recycle", value: e.target.checked },
                    })
                  }
                />
              </td>
            </tr>
          )}
          {postiValid && (
            <tr>
              <td className="align-middle px-0  pb-1" colSpan={2}>
                <CheckBoxInput
                  choised="connect"
                  color="#f7951e"
                  text="Connect"
                  checked={variables.connect}
                  onChange={(e) =>
                    handleChangeText({
                      target: { name: "connect", value: e.target.checked },
                    })
                  }
                />
              </td>
            </tr>
          )} */}
          <tr>
            {!["at_the_store"].includes(order_type) && (
              <td className="d-flex align-items-center align-middle px-0  pb-1">
                <CheckBoxInput
                  choised="cod"
                  color="#f7951e"
                  text="COD"
                  checked={variables.cod}
                  disabled={isCodDisabledByParcelTerminal}
                  onChange={(e) => {
                    if (isCodDisabledByParcelTerminal) {
                      return;
                    }

                    if (!e.target.checked) {
                      confirm({
                        title: "Are you sure?",
                        content: "You are about to disable COD",
                        onOk() {
                          handleLoggerUpdate(e.target.checked, "COD");
                          handleChangeText({
                            target: { name: "cod", value: e.target.checked },
                          });
                        },
                        onCancel() { },
                      });
                    } else {
                      handleLoggerUpdate(e.target.checked, "COD");
                      handleChangeText({
                        target: { name: "cod", value: e.target.checked },
                      });
                    }
                  }}
                />
                {variables.cod &&
                  (cod_details ? (
                    cod_details.waiting_payments.filter((e) => e.cod).length >
                      0 ? (
                      <RenderIndexOrderCOD
                        cod_details={cod_details}
                        cod_amount={variables.cod_amount}
                        handleChangeText={(value) => {
                          handleChangeText({
                            target: { name: "cod_amount", value },
                          });
                        }}
                      />
                    ) : null
                  ) : (
                    <RenderShowOrderCOD
                      cod_amount={variables.cod_amount}
                      handleChangeText={(value) => {
                        handleChangeText({
                          target: { name: "cod_amount", value },
                        });
                      }}
                    />
                  ))}
                {isCodDisabledByParcelTerminal && (
                  <div className="ml-2">
                    <small className="text-muted">
                      COD is not available for this parcel terminal
                    </small>
                  </div>
                )}
              </td>
            )}
            {variables.cod && (
              <td className="pr-0  pb-1">
                <div className="row">
                  <div className="col-5 my-auto text-right px-0">
                    <div className="d-flex justify-content-end">
                      {!!order_rows_total && (
                        <TooltipInfo title="COD left">
                          {numberRound(order_rows_total)}
                        </TooltipInfo>
                      )}
                      <div className="font-semi-bold text-xs my-auto">
                        Sum EUR
                      </div>
                    </div>
                  </div>
                  <div className="col-7  pl-2">
                    <Input
                      placeholder="Enter"
                      type="number"
                      name="cod_amount"
                      value={variables.cod_amount}
                      onChange={(e) => handleChangeText(e)}
                      onBlur={(e) => handleCodAmountLog(e.target.value)}
                    />
                  </div>
                </div>
              </td>
            )}
          </tr>
          {/* LP express after 18 */}
          {order_type === "lp_express" &&
            delivery == "lp_express_home" &&
            country_id == 122 && (
              <tr>
                <td className="align-middle px-0 pb-1" colSpan={2}>
                  <CheckBoxInput
                    text="Delivery after 18:00"
                    checked={variables.delivery_after_18}
                    onChange={(e) =>
                      handleChangeText({
                        target: {
                          name: "delivery_after_18",
                          value: e.target.checked,
                        },
                      })
                    }
                  />
                </td>
              </tr>
            )}
          {/* END LP express after 18 */}
          {order_type === "dpd" && (
            <tr>
              <td className="align-middle px-0  pb-1">
                <CheckBoxInput
                  choised="sending_doc"
                  color="#f7951e"
                  text="Documents to be sent"
                  checked={variables.sendingDocuments}
                  onChange={(e) =>
                    handleChangeText({
                      target: {
                        name: "sendingDocuments",
                        value: e.target.checked,
                      },
                    })
                  }
                />
              </td>
              {order_type === "dpd" && variables.sendingDocuments && (
                <td className="pr-0 pb-1">
                  <div className="row">
                    <div className="col-5 my-auto text-right pr-0">
                      <span className="text-bold my-auto">Who?</span>
                    </div>
                    <div className="col-7  pl-2">
                      <Input
                        placeholder="Enter"
                        name="who"
                        value={variables.who}
                        onChange={(e) => handleChangeText(e)}
                      />
                    </div>
                  </div>
                </td>
              )}
            </tr>
          )}
          {(order_type === "dpd" || order_type === "own_transport") && (
            <tr>
              <td className="align-middle px-0  pb-1">
                <CheckBoxInput
                  choised="delivery_time"
                  color="#f7951e"
                  text="Delivery time"
                  checked={variables.deliveryTime}
                  onChange={(e) =>
                    handleChangeText({
                      target: {
                        name: "deliveryTime",
                        value: e.target.checked,
                      },
                    })
                  }
                />
              </td>
              {order_type !== "omniva" && variables.deliveryTime && (
                <td className="pr-0 pb-1">
                  <div className="row">
                    <div className="col-5 my-auto  text-right pr-0">
                      <span className="text-bold my-auto">When?</span>
                    </div>
                    <div className="col-7 my-auto  pl-2">
                      <RangePickerComp
                        format="HH:mm"
                        showTime={{ format: "HH:mm" }}
                        placeholder={["From", "To"]}
                        disabledHours={() => [
                          0, 1, 2, 3, 4, 5, 6, 7, 19, 20, 21, 22, 23,
                        ]}
                        hideDisabledOptions={true}
                        onChange={(_, args) => {
                          handleChangeText({
                            target: {
                              name: "deliveryTimeHours",
                              value: args,
                            },
                          });
                        }}
                      />
                    </div>
                  </div>
                </td>
              )}
            </tr>
          )}
          {order_type === "dpd" && (
            <tr>
              <td className="align-middle px-0 pb-1" colSpan={2}>
                <CheckBoxInput
                  choised="delivery_saturday"
                  color="#f7951e"
                  text="Delivery on Saturday"
                  checked={variables.deliveryOnSaturday}
                  onChange={(e) =>
                    handleChangeText({
                      target: {
                        name: "deliveryOnSaturday",
                        value: e.target.checked,
                      },
                    })
                  }
                />
              </td>
            </tr>
          )}
          {order_type === "dpd" && (
            <tr>
              <td className="align-middle px-0 pb-1" colSpan={2}>
                <CheckBoxInput
                  choised="delivery_same_day"
                  color="#f7951e"
                  text="Same day delivery"
                  checked={variables.delivery_same_day}
                  onChange={(e) =>
                    handleChangeText({
                      target: {
                        name: "delivery_same_day",
                        value: e.target.checked,
                      },
                    })
                  }
                />
              </td>
            </tr>
          )}
          {!["at_the_store"].includes(order_type) && (
            <tr>
              <td className="align-middle px-0 pb-1" colSpan={2}>
                <CheckBoxInput
                  choised="order_return"
                  color="#f7951e"
                  text="Pickup from the customer"
                  checked={variables.order_return}
                  onChange={(e) =>
                    handleChangeText({
                      target: {
                        name: "order_return",
                        value: e.target.checked,
                      },
                    })
                  }
                />
              </td>
            </tr>
          )}
          {(order_type === "own_transport" ||
            (order_type === "dpd" && delivery !== "dpd_postMachine")) && (
              <tr>
                <td className="align-middle px-0 pb-1" colSpan={2}>
                  <CheckBoxInput
                    choised="swap"
                    name="swap"
                    color="#f7951e"
                    text="SWAP"
                    checked={variables.swap}
                    onChange={(e) =>
                      handleChangeText({
                        target: { name: "swap", value: e.target.checked },
                      })
                    }
                  />
                </td>
              </tr>
            )}
          <tr>
            <td className="align-middle px-0 pb-1" colSpan={2}>
              <div>
                <CheckBoxInput
                  name={"skip_labels"}
                  text={"Do not generate label"}
                  checked={skip_labels}
                  onChange={(e) => {
                    setSkipLabels(e.target.checked);
                  }}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td className="align-middle px-0 pb-1" colSpan={2}>
              <div>
                <CheckBoxInput
                  name={"ignore_stock_check"}
                  text={"Ignore stock check"}
                  checked={variables.ignore_stock_check}
                  onChange={(e) => {
                    handleChangeText({
                      target: {
                        name: "ignore_stock_check",
                        value: e.target.checked,
                      },
                    });
                  }}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {!!warningMessages.length &&
        warningMessages.map((message) => (
          <div key={message} className="text-sm text-danger mb-2">
            {message}
          </div>
        ))}
    </>
  );
}

const RenderIndexOrderCOD = ({ handleChangeText, cod_details, cod_amount }) => {
  const default_cod = cod_details.default_cod;
  const waiting_payment_filtered = cod_details.waiting_payments.filter(
    (e) => e.cod
  );

  return (
    <Tooltip
      placement="top"
      title={
        <span>
          <span>
            Default COD:{" "}
            <span
              className={`cursor-pointer ${default_cod == cod_amount
                ? "text-white font-weight-bold"
                : "text-orange"
                }`}
              onClick={() => handleChangeText(default_cod)}
            >
              {default_cod}
            </span>
          </span>
          {waiting_payment_filtered.length > 0 && (
            <Fragment>
              {" | "}
              <span>
                Payments COD:
                {waiting_payment_filtered.map((e, idx) => (
                  <Fragment key={idx}>
                    <span
                      className={`cursor-pointer ${e.price == cod_amount
                        ? "text-white font-weight-bold"
                        : "text-orange"
                        }`}
                      onClick={() => handleChangeText(e.price || 0)}
                    >
                      {e.price || 0}
                    </span>
                    {waiting_payment_filtered.length - 1 == idx ? "" : " / "}
                  </Fragment>
                ))}
              </span>
            </Fragment>
          )}
        </span>
      }
    >
      <FiAlertCircle className="text-danger cursor-pointer" />
    </Tooltip>
  );
};

const RenderShowOrderCOD = ({ handleChangeText, cod_amount }) => {
  const {
    order: { leasing_cod, leasing_advance, total_price, waiting_payments },
  } = useSelector((state) => state.orders);
  const default_cod = leasing_cod ? leasing_advance : total_price || 0;
  const waiting_payment_filtered = waiting_payments.filter((e) => e.cod);

  if (waiting_payment_filtered.length == 0) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      title={
        <span>
          <span>
            Default COD:{" "}
            <span
              className={`cursor-pointer ${default_cod == cod_amount
                ? "text-white font-weight-bold"
                : "text-orange"
                }`}
              onClick={() => handleChangeText(default_cod)}
            >
              {default_cod}
            </span>
          </span>
          {waiting_payment_filtered.length > 0 && (
            <Fragment>
              {" | "}
              <span>
                Payments COD:
                {waiting_payment_filtered.map((e, idx) => (
                  <Fragment key={idx}>
                    <span
                      className={`cursor-pointer ${e.price == cod_amount
                        ? "text-white font-weight-bold"
                        : "text-orange"
                        }`}
                      onClick={() => handleChangeText(e.price || 0)}
                    >
                      {e.price || 0}
                    </span>
                    {waiting_payment_filtered.length - 1 == idx ? "" : " / "}
                  </Fragment>
                ))}
              </span>
            </Fragment>
          )}
        </span>
      }
    >
      <FiAlertCircle className="text-danger cursor-pointer" />
    </Tooltip>
  );
};

const categorizePostiService = (order_row) => {
  if (
    [
      "Senos technikos išvežimas ir naujos prijungimas",
      "Vanhojen laitteiden poistaminen ja uusien kytkeminen",
    ].includes(order_row.product_name)
  ) {
    return "recycle_connect";
  }
  if (
    ["Senos technikos išvežimas", "Vanhojen laitteiden poistaminen"].includes(
      order_row.product_name
    )
  ) {
    return "recycle";
  }
  if (
    ["Naujos technikos prijungimas", "Uusien laitteiden kytkeminen"].includes(
      order_row.product_name
    )
  ) {
    return "connect";
  }
  return null;
};
const RenderPostiServices = ({
  order_rows = [],
  variables,
  handleChangeText,
}) => {
  useEffect(() => {
    order_rows.forEach((order_row) => {
      if (!order_row?.selected) return;
      const val = categorizePostiService(order_row);
      if (val) {
        val.split("_").forEach((name) => {
          handleChangeText({
            target: { name, value: true },
          });
        });
      }
      order_row?.childs?.forEach((child) => {
        const val = categorizePostiService(child);
        if (val) {
          val.split("_").forEach((name) => {
            handleChangeText({
              target: { name, value: true },
            });
          });
        }
      });
    });
  }, [order_rows.length]);

  return (
    <>
      <tr>
        <td className="align-middle px-0  pb-1" colSpan={2}>
          <CheckBoxInput
            choised="recycle"
            color="#f7951e"
            text="Recycle"
            checked={variables.recycle}
            onChange={(e) =>
              handleChangeText({
                target: { name: "recycle", value: e.target.checked },
              })
            }
          />
        </td>
      </tr>
      <tr>
        <td className="align-middle px-0  pb-1" colSpan={2}>
          <CheckBoxInput
            choised="connect"
            color="#f7951e"
            text="Connect"
            checked={variables.connect}
            onChange={(e) =>
              handleChangeText({
                target: { name: "connect", value: e.target.checked },
              })
            }
          />
        </td>
      </tr>
    </>
  );
};
